/* global angular, window */

var ngModule = angular.module('trends');
var $ = jQuery;

ngModule.service('TraceService',
    function () {
        // Use window global here to avoid dependending on angular service
        if (window.StackTrace === undefined) {
            this.fromError = function () {
                // Fake up a promise
                return {
                    then: function (fn) {
                        fn([]);
                    }
                };
            };
        }
        else {
            this.fromError = window.StackTrace.fromError;
        }
    });

ngModule.factory('exceptionLoggingService', ['$log', 'TraceService', 'BrowserDetector',
    function ($log, TraceService, BrowserDetector) {
        return function (exception, cause) {
            // preserve default logging behaviour
            $log.error.apply($log, arguments);

            // Skip client side logging for IE8
            var browser = BrowserDetector.getBrowserInfo();
            if (browser.name === 'MSIE' && browser.version === '8') {
                return;
            }

            // error handler for failed log attempts
            var logErrorHandler = function (loggingError) {
                $log.warn('Error logging to server');
                $log.warn(loggingError);
            };

            // try to log to server
            try {
                var message = exception.toString();

                // get stack trace
                var promise = TraceService.fromError(exception);

                // submit log entry to server
                promise.then(function (trace) {
                    $.ajax({
                        type: 'POST',
                        url: '/trends/api/v1/clientlog/',
                        contentType: 'application/json',
                        data: angular.toJson({
                            url: window.location.href,
                            message: message,
                            type: 'exception',
                            cause: (cause || ''),
                            useragent: window.navigator.userAgent,
                            stacktrace: trace,
                        }),
                        global: false,
                        error: function (req, textStatus, errorThrown) {
                            logErrorHandler((textStatus || 'unknown') + ' - ' + errorThrown);
                        }
                    });
                });
            } catch (loggingError) {
                logErrorHandler(loggingError);
            }
        };
    }
]);

ngModule.provider('$exceptionHandler', function () {
    this.$get = ['exceptionLoggingService',
        function (exceptionLoggingService) {
            return exceptionLoggingService;
        }
    ];
});
